"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var Elements_1 = require("../Elements");
var useBody_1 = require("./useBody");
var DataTable = function (_a) {
    var _b = _a.itemsPerPage, itemsPerPage = _b === void 0 ? 5 : _b, _c = _a.lazy, lazy = _c === void 0 ? true : _c, data = _a.data, loading = _a.loading;
    var _d = (0, react_1.useState)(5), itemsInPage = _d[0], setItemsInPage = _d[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var loadMoreClick = (0, react_1.useCallback)(function () {
        setItemsInPage(itemsInPage + itemsPerPage);
    }, [itemsInPage, itemsPerPage]);
    (0, react_1.useLayoutEffect)(function () {
        setItemsInPage(itemsPerPage);
    }, [itemsPerPage]);
    var body = (0, useBody_1.useBody)({
        lazy: lazy,
        columns: data.columns,
        itemsInPage: itemsInPage,
        rows: data.rows,
        fullInfoRows: data.fullInfoRows,
    });
    if (loading !== undefined && loading) {
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    }
    return (react_1.default.createElement("div", null,
        data.rows.length === 0 ? (react_1.default.createElement(Elements_1.NoData, null, t('noData'))) : (react_1.default.createElement(Elements_1.Table, null,
            react_1.default.createElement(Elements_1.Head, null,
                react_1.default.createElement(Elements_1.Row, null,
                    data.columns.map(function (column) { return (react_1.default.createElement(Elements_1.Cell, { key: column.field }, column.label)); }),
                    react_1.default.createElement(Elements_1.Cell, null))),
            react_1.default.createElement(Elements_1.Body, null, body))),
        lazy && data.rows.length > itemsInPage && (react_1.default.createElement("div", { style: { marginTop: '10px', textAlign: 'center' } },
            react_1.default.createElement(ui_components_1.LoadMoreButton, { onClick: loadMoreClick }, t('loadMore'))))));
};
exports.default = DataTable;
